import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import {
    BlockGroupCompositionBody,
    BlockGroupCompositionDetails,
    BlockGroupCompositionListItem,
} from "types/api/blockGroupComposition";

import { AdvancedListRequest } from "types/api/commons";

function useBlockGroupCompositionApi() {
    const { get, post, put } = useHttpManaged();
    const getAllBlockGroupComposition = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<BlockGroupCompositionListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<BlockGroupCompositionListItem>>({
            url: "/block-group-composition",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneBlockGroupComposition = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<BlockGroupCompositionDetails> => {
        return get<PathParamsWithId, undefined, BlockGroupCompositionDetails>({
            url: "/block-group-composition/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createBlockGroupComposition = React.useCallback((body: BlockGroupCompositionBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, BlockGroupCompositionBody, ResponseWithId>({
            url: "/block-group-composition",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateBlockGroupComposition = React.useCallback((pathParams: PathParamsWithId, body: BlockGroupCompositionBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, BlockGroupCompositionBody, null>({
            url: "/block-group-composition/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    return {
        getAllBlockGroupComposition,
        getOneBlockGroupComposition,
        createBlockGroupComposition,
        updateBlockGroupComposition
    };
}

export default useBlockGroupCompositionApi;